import { Injectable } from '@angular/core';
// import { Address } from 'src/app/models/address.model';
// import { Category } from 'src/app/models/category.model';
// import { Item } from 'src/app/models/item.model';
// import { Order } from 'src/app/models/order.model';
import { 
  addDoc, collection, collectionData, deleteDoc, doc, endAt, 
  Firestore, getDoc, getDocs, limit, orderBy, query, setDoc, 
  startAt, updateDoc, where ,onSnapshot
} from '@angular/fire/firestore';
import { GeoPoint, getFirestore } from 'firebase/firestore';
import { getDownloadURL, ref, Storage } from '@angular/fire/storage';
import { environment } from 'src/environments/environment';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { map, switchMap, } from 'rxjs/operators';

import { AlertController } from '@ionic/angular'; // Import AlertController

import { getAuth, getIdToken,signInWithEmailAndPassword } from '@angular/fire/auth';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { uploadBytes,uploadBytesResumable } from 'firebase/storage';



@Injectable({
  providedIn: 'root'
})
export class ApiService {

  db = getFirestore();
  images = [];
  documents = [];
  deliveryEnd = ''
  deliveryStart = '';
  // orderSegment = 'new'

  constructor(  private firestore: Firestore, private storage: Storage, private http: HttpClient, private alertController: AlertController // Inject AlertController

  ) {}

  collectionRef(path: any) {
    return collection(this.firestore, path);
  }

  docRef(path:any) {
    return doc(this.firestore, path);
  }

  document(path:any) {
    return doc(this.db, path);
  }

  collectionDataQuery(path:any, id?:any) {
    let dataRef = this.collectionRef(path);
    let collection_data;
    if(id) collection_data = collectionData<any>(dataRef, {idField: 'id'});
    else collection_data = collectionData<any>(dataRef); //valuechanges, for doc use docData
    return collection_data;
  }

  setDocument(path:any, data:any) {
    const dataRef = this.docRef(path);
    return setDoc(dataRef, data); //set()
  }

  getDocs(path:any, queryFn?:any) {
    let dataRef: any = this.collectionRef(path);
    if(queryFn) {
      const q = query(dataRef, queryFn);
      dataRef = q;
    }
    return getDocs(dataRef); //get()
  }

  getDocById(path:any) {
    const dataRef = this.docRef(path);
    return getDoc(dataRef);
  }

  updateDocument(path:any, data:any) {
    const dataRef = this.docRef(path);
    return updateDoc(dataRef, data); //update()
  }

  async uploadImage(file:any, filePath:any) {
    try {
      const fileRef = ref(this.storage, filePath);
      const task = await uploadBytes(fileRef, file);
      const url = getDownloadURL(fileRef);
      return url;
    } catch(e) {
      throw(e);
    }
  }

  getDocRef(path: string) {
    return doc(this.firestore, path);  // Assuming firestore is already initialized
  }



  async apiPost(data: any, url: any) {
    try {
      const auth = getAuth();
      let currentUser = auth.currentUser;
  
      if (!currentUser) {
        const credentials = await this.showLoginPrompt();
        if (!credentials) {
          throw new Error('Login canceled');
        }
  
        const userCredential = await signInWithEmailAndPassword(auth, credentials.email, credentials.password);
        currentUser = userCredential.user;
      }
  
      const accessToken = await getIdToken(currentUser, true);
      data.env = environment.prefix;
      data.uid = currentUser.uid;
      const fullUrl = environment.api + url;
      let headers;
      headers = { Authorization: 'Bearer ' + accessToken };
      headers.env = environment.prefix;
      headers.uuid = currentUser.uid;
  
      return this.http.post(fullUrl, data, { headers });
    } catch (error) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        this.showInvalidCredentialsAlert();
        throw new Error('Invalid credentials.'); // Ensure to throw the error again
      } else {
        console.error('Error in apiPost:', error);
        throw new Error('An error occurred. Please try again later.'); // Re-throw the error
      }
    }
  }

  async apiPatch(data:any, url:any ) {
    const auth = getAuth()
    const { currentUser } = auth
    const accessToken = await getIdToken(currentUser, true)
    data.env = environment.prefix
    data.uuid = currentUser.uid
    const fullUrl = environment.api + url;
    let headers;
    headers = { Authorization: 'Bearer ' + accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
    // console.log(data)
    return this.http.patch(fullUrl, data, {headers});
  }

  async apiPut(data: any, url: any) {
    const auth = getAuth();
    const { currentUser } = auth;
    const accessToken = await getIdToken(currentUser, true);
    
    // Adding the environment prefix and user uuid to the data
    data.env = environment.prefix;
    data.uuid = currentUser.uid;
    let headers;
    headers = { Authorization: 'Bearer ' + accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
  
    const fullUrl = environment.api + url;
    
    // Making the PUT request instead of PATCH
    return this.http.put(fullUrl, data, { headers });
  }



  async apiGet(params: any, url: any) {
    const auth = getAuth();
    const { currentUser } = auth;
    const accessToken = await getIdToken(currentUser, true);
  
    // Add environment prefix and user ID to the parameters
    params.env = environment.prefix;
    params.uuid = currentUser.uid;
  
    const fullUrl = environment.api + url;
    let headers;
    headers = { Authorization: 'Bearer ' + accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
  
    // Make the GET request with headers and parameters
    // console.log(params);
    return this.http.get(fullUrl, { headers, params });
  }
  

  async apiDelete(data:any, url:any ) {
    const auth = getAuth()
    const { currentUser } = auth
    const accessToken = await getIdToken(currentUser, true)
    data.env = environment.prefix
    data.uuid = currentUser.uid
    const fullUrl = environment.api + url;
    let headers;
    headers = { Authorization: 'Bearer ' + accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
    return this.http.patch(fullUrl, data, {headers});
  }

  reverseGeocode(latitude: number, longitude: number) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${environment.mapKey}`
        )
        .pipe(
          map(geoData => {
            if(!geoData || !geoData.results || geoData.results.length === 0) throw(null);
            return geoData.results;
          })
        ).subscribe(data => {
          resolve(data);
        }, e => {
          reject(e);
        });
    });
  }
  

  banners = [  
    {banner: 'assets/imgs/1.jpg'},
    {banner: 'assets/imgs/2.jpg'},
    {banner: 'assets/imgs/3.jpg'}  
  ];
  
  
  async postMessage(data:any, url:any ) {
    try {
      const apiCallPromise = new Promise<void>(async (resolve, reject) => {
        (await this.apiPost(data, url)).subscribe({
          next: async (res) => {
            if (res['status'] === 'Success') {
              resolve(); // Resolve the promise when the API call is successful
            } else {
              console.log('Failed');
              reject('API call failed'); // Reject the promise if the API call fails
            }
          },
          error: (err) => {
            console.error('Error:', err);
            reject(err); // Reject the promise if there's an error in the subscription
          }
        });
      });
  
      // Await the promise to ensure the API call completes before continuing
      await apiCallPromise;
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  }

  async getToken(){
    const auth = getAuth()
    const { currentUser } = auth
    const accessToken = await getIdToken(currentUser, true)
    return accessToken
  }

  async patchMessage(data:any, url:any ) {
    try {
      const apiCallPromise = new Promise<void>(async (resolve, reject) => {
        (await this.apiPatch(data, url)).subscribe({
          next: async (res) => {
            if (res['status'] === 'Success') {
              resolve(); // Resolve the promise when the API call is successful
            } else {
              console.log('Failed');
              reject('API call failed'); // Reject the promise if the API call fails
            }
          },
          error: (err) => {
            // console.error('Error:', err);
            reject(err); // Reject the promise if there's an error in the subscription
          }
        });
      });
  
      // Await the promise to ensure the API call completes before continuing
      await apiCallPromise;
    } catch (error) {
      // console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  }

  apiAnonymousPost(data:any, url:any, accessToken? ): Observable<any> {
    const auth = getAuth()
    const { currentUser } = auth
    data.env = environment.prefix
    const fullUrl = environment.api + url;
    // console.log('Access token:',accessToken)
    let headers;
    headers = { Authorization: 'Bearer '+ accessToken };
    headers.env = environment.prefix;
    headers.uuid = currentUser.uid;
    return this.http.post(fullUrl, data, {headers});
  }

  private async showLoginPrompt(): Promise<{ email?: string; password?: string } | null> {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        header: 'Login Required',
        inputs: [
          {
            name: 'email',
            type: 'email',
            placeholder: 'Email',
          },
          {
            name: 'password',
            type: 'password',
            placeholder: 'Password',
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => resolve(null), // Resolve with null on cancel
          },
          {
            text: 'Login',
            handler: (credentials) => {
              if (credentials.email && credentials.password) {
                resolve(credentials);
              } else {
                // Handle empty fields, maybe show an error message
                resolve(null); 
              }
            },
          },
        ],
      });

      await alert.present();
    });
  }

  private async showInvalidCredentialsAlert() {
    const alert = await this.alertController.create({
      header: 'Invalid Credentials',
      message: 'The email or password you entered is incorrect.',
      buttons: ['OK'],
    });
    await alert.present();
  }

 
  subscribeToCollection(
    collectionPath: string,
    targetSubject?: BehaviorSubject<any[]>
  ) {
    const documentRef = environment.prefix + collectionPath;
    const collectionRef = this.collectionRef(documentRef);
    
   
    const q = query(
      collectionRef,
     // Filter events where endDateTime is greater than current time
      orderBy('state', 'desc') // Order by endDateTime ascending
    );
  
    onSnapshot(q, (snapshot) => {
      const meetings = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // console.log(orders)
      targetSubject.next(meetings);
    }, (error) => {
      console.error(`Error fetching ${collectionPath} documents:`, error);
      // Handle error appropriately
    });
  }

  async uploadImageWithProgress(file:any, filePath:any, onProgress: (progress: number) => void) {
    try {
      const fileRef = ref(this.storage, filePath);
      // const task = await uploadBytes(fileRef, file);
      // Create a reference for a resumable upload
      const task = uploadBytesResumable(fileRef, file);


       // Listen to the upload progress
       task.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            onProgress(progress);
        });

        // Wait for the upload to complete
        await task;

      const url = await getDownloadURL(fileRef);
      return url;
    } catch(e) {
      throw(e);
    }
  }

  

}

interface Vendor {
  id: string;
  // ... other vendor properties
}

interface VendorResponse {
  vendors: Vendor[];
  nextPage: string | null; // Or string | undefined

}